import { useMemo } from 'react';
import { useWetagStore, type WetagStore } from '@frontend/shared';

export const useWeTags = (weTag: string) => {
  const weTagSelector = useMemo(() => (state: WetagStore) => state.enabledWeTags[weTag], [weTag]);
  const isWeTagEnabled = useWetagStore(weTagSelector);

  return isWeTagEnabled;
};
